<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>

            <section class="client-section">
                <div class="d-md-none">
                    <v-img src="/images/business/domestic/care/middle.jpg" alt="" />
                </div>

                <div class="d-none d-md-block">
                    <v-card img="/images/business/domestic/care/business.jpg" color="#FEFCFB" tile flat>
                        <v-responsive :aspect-ratio="1920 / 432">
                            <v-container class="h-100 py-50">
                                <v-row align="center" class="h-100">
                                    <v-col cols="12" lg="5">
                                        <v-row>
                                            <v-col cols="12">
                                                <div class="tit tit--sm font-weight-regular line-height-15">
                                                    <strong class="primary--text">가장 도움이 필요한</strong> 아이들에게, <br />
                                                    <strong class="primary--text">가장 효과적이고 투명한 돌봄</strong>을 제공합니다.
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <p class="page-text page-text--lg grey-1--text">
                                                    위드캔복지재단과 함께하면, <br />
                                                    아이들이 가난과 결핍을 넘어 꿈과 희망을 키울 수 있습니다.
                                                </p>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-responsive>
                    </v-card>
                </div>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <program-list :items="programs" />
                </v-container>
            </section>
        </div>
        <section>
            <bottom-banner :item="banner" />
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
    },
    data() {
        return {
            visual: {
                sh: "국내복지사업",
                tabActive: "아동돌봄사업",
                text: "우리는 단순한 지원을 넘어, 지속 가능한 변화를 만들어 갑니다.",
                bg: "/images/business/domestic/visual.jpg",
                mobile: "/images/business/domestic/mobile-visual.jpg",
            },
            intro: {
                image: "/images/business/domestic/care/intro.jpg",
                texts: "어려움에 처한 아동들이 안전한 환경에서 보호받고, 건강하게 성장하며 꿈을 키워갈 수 있도록 지원합니다. <br class='d-none d-xl-block' /> 위기 상황에서의 긴급 돌봄부터 지속 가능한 성장 지원까지, 아이들의 삶에 변화를 가져오는 돌봄 및 복지 서비스를 제공합니다.",
            },
            programs: [
                {
                    image: "/images/business/domestic/care/program-1.jpg",
                    title: "위기가정아동지원",
                    texts: [
                        "갑작스러운 위기로 어려움에 처한 아동과 가정에 복지 서비스를 제공하여, 위기 아동을 발굴·의뢰, 주거·의료·학업 지원 등을 진행합니다.",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/care/program-2.jpg",
                    title: "인재양성 사업",
                    texts: [
                        "꿈과 재능을 가진 아이들이 어려움 속에서도 포기하지 않고 무한한 잠재력을 발휘하여 미래를 이끌어갈 인재로 성장할 수 있도록 지원합니다.",
                        //
                    ],
                },
            ],
            banner: {
                image: "/images/business/domestic/care/bottom-banner.jpg",
                mobile: "/images/business/domestic/care/bottom.jpg"
            },
        };
    },
};
</script>